"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_consultant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "customer-care-mid"), /*#__PURE__*/React.createElement("g", {
    id: "e7388d1d-f005-42bf-9d37-04d1b488c61b",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3f09496d-1f30-4cf0-bd87-f9cff0360043",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,76A12,12,0,0,1,52,88v24a12,12,0,0,1-24,0V88A12,12,0,0,1,40,76m0-4A16,16,0,0,0,24,88v24a16,16,0,0,0,32,0V88A16,16,0,0,0,40,72Z",
    transform: "translate(0 0)",
    fill: "#6d6a69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,76a12,12,0,0,1,12,12v24a12,12,0,0,1-24,0V88a12,12,0,0,1,12-12m0-4a16,16,0,0,0-16,16v24a16,16,0,0,0,32,0V88a16,16,0,0,0-16-16Z",
    transform: "translate(0 0)",
    fill: "#6d6a69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,88V78s2-60,70-60,70,60,70,60V88",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d6a69",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,124.76C159.89,138.35,152.35,160,122,160",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d6a69",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.82,123q-.08.84-.2,1.73",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d6a69",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,148a12,12,0,1,1,0,24H84a12,12,0,1,1,0-24h24m0-4H84a16,16,0,1,0,0,32h24a16,16,0,1,0,0-32Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }))));
}

var _default = ic_consultant;
exports.default = _default;